import { Box, BoxProps } from '@mui/material'
import { NameWithFavicon } from './NameWithFavicon'

type TProps = BoxProps & {
  name: string
  client?: {
    /**
     * The vendor's name
     */
    name: string
    /**
     * The vendor's website
     */
    website?: string | null
  }
}
/**
 * A component that displays a project's name and a byline with the vendor's
 * name and website favicon. Useful for visually differentiating between
 * projects in lists.
 */
export const ProjectWithClientIcon = (props: TProps) => {
  const { name, client, ...passedProps } = props

  return (
    <Box display="flex" flexDirection="column" {...passedProps}>
      <Box display="flex" flexDirection="column">
        <Box mb={0}>{name}</Box>
        {client && <NameWithFavicon {...client} size="sm" sx={{ mt: '-0.15rem' }} />}
      </Box>
    </Box>
  )
}
